import * as React from 'react';
import { useCallback } from 'react';

import Radio from 'af-components/Controls/Radio';

interface OwnProps {
	tag: string;
	isChecked: boolean;
	className?: string;
	onSelect: (tag: string) => void;
}

type Props = OwnProps;

const TagRadio: React.FC<Props> = (props) => {
	const { className, isChecked, tag, onSelect } = props;

	const handleCheck = useCallback(() => {
		onSelect(tag);
	}, [onSelect, tag]);

	return (
		<Radio checked={isChecked} className={className} label={tag} onCheck={handleCheck} />
	);
};

export default React.memo(TagRadio);
